import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { ProgressNotesModel } from '../models/ProgressNotesModel';


@Injectable()
export class ProgressNotesService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

    public getProgressNotesPatient(PatientCode: string) {
      let params = new HttpParams();
      params = params.append("PatientCode", PatientCode);
      const options = {
          params: params
      };
      return this.http.get<ProgressNotesModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/ProgressNotes/GetProgressNotes_Patient', options);
    }
    public getProgressNotes(PatientCode: string,ProgDate:string,userid :string) {
      let params = new HttpParams();
      params = params.append("ProgDate", ProgDate);
      params = params.append("PatientCode", PatientCode);
      params = params.append("userid", userid);
      const options = {
          params: params
      };
      return this.http.get<ProgressNotesModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProgressNotes/GetProgressNotes', options);
    }
    public AddProgressNotes(ProgressNotes: ProgressNotesModel) {
            return this.http.post<ProgressNotesModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProgressNotes/AddProgressNotes', ProgressNotes);
    }
    public deleteProgressNotes(ProgDate:string ,PatientCode: string,userid :string) {
      let params = new HttpParams();
      params = params.append("ProgDate", ProgDate);
      params = params.append("PatientCode", PatientCode);
      params = params.append("userid", userid);
      const options = {
          params: params
      };

      return this.http.get<ProgressNotesModel>(this.urlsconfig.WebAPIURL_Test + 'api/ProgressNotes/DelProgressNotes', options);
    }
}
